import { useEffect } from 'react';
import { RouterProvider } from 'react-router';
import { Toaster } from 'sonner';
import { router } from './routes.tsx';
import { trackPageView } from '../lib/analytics.ts';

export default function App() {
  // Meta Pixel — initAnalyticsWithConsent() (in main.tsx) fires the PageView
  // for the initial load once the visitor has consented; this client-routed
  // SPA needs an explicit PageView on each subsequent navigation.
  // router.subscribe only fires on changes AFTER the current state, so the
  // first load isn't double-counted; we de-dupe per location key (a single
  // navigation emits a loading→idle pair). trackPageView() is a no-op when the
  // pixel isn't loaded (dev / non-prod / consent not granted), so this is safe
  // to run unconditionally.
  useEffect(() => {
    let lastKey = router.state.location.key;
    const unsubscribe = router.subscribe((state) => {
      if (state.location.key !== lastKey) {
        lastKey = state.location.key;
        trackPageView();
      }
    });
    return unsubscribe;
  }, []);

  return (
    <>
      <RouterProvider router={router} />
      {/* App-wide toast surface. Forms use lib/toast.ts to push messages. */}
      <Toaster
        position="top-right"
        richColors
        closeButton
        duration={4000}
      />
    </>
  );
}